import { observer } from 'mobx-react-lite';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';
import { Button, Dropdown } from 'semantic-ui-react';
import CrmFormFields from './CrmFormFields';
import HistoryModel from './HistoryModel';
import { createCRMAssetInitialState } from '../../../app/models/Restoration';
import agent from '../../../app/api/agent';

const CRMAssetTracking = () => {
  const { dashboardStore, CRMStore } = useStore();
  const { assetTracking, handleCrmAssetTracking, handleDeptList } = CRMStore;
  const [assetCount, setAssetCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    handleDeptList();
    handleCrmAssetTracking(currentPage, pageSize, []);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const isNormal = Object.keys(dashboardStore.dashboard.searchfilterparams).length === 0;
    setAssetCount(isNormal ? assetTracking.count : assetTracking.searchCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetTracking.count, assetTracking.searchCount, dashboardStore.dashboard.searchfilterparams]);

  const paginateFunction = (e: number) => {
    const result: any[] =
      dashboardStore.dashboard.searchfilterparams === null
        ? []
        : Object.entries(dashboardStore.dashboard.searchfilterparams).map(
            ([key, value]) => ({
              headerName: key,
              searchValue: value || '',
            }),
          );
    handleCrmAssetTracking(e, pageSize, result);
    dashboardStore.setTagPageNumFunc(e);
    CRMStore.assetTracking.pageNumber = e;
    setCurrentPage(e);
  };

  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };

  return (
    <>
      <h3 style={{ marginLeft: '20px' }}>CRM Asset Tracking</h3>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          margin: '20px',
        }}
      >
        <Dropdown
          style={{ width: '250px' }}
          placeholder="Select Department"
          fluid
          selection
          clearable
          value={CRMStore.assetTracking.deptValue}
          options={CRMStore.assetTracking.deptList}
          onChange={async (e, data) => {
            CRMStore.assetTracking.deptValue = data.value as string;
            CRMStore.assetTracking.pageNumber = 1;
            setCurrentPage(1);
            if (data.value === '') {
              CRMStore.handleCrmAssetTracking(1, pageSize, []);
              dashboardStore.dashboard.searchfilterparams = {};
            } else {
              dashboardStore.dashboard.searchfilterparams = {
                department: data.value,
              };
              const response = await agent.CRMAssetTracking.searchCRMAsset(1, pageSize, [{ headerName: 'department', searchValue: data.value }]);
              const response1 = await agent.CRMAssetTracking.departmentSearchCount();
              const filteredCount = response1.data.find((item: any) => item.department === data.value)?.count || 0;
              CRMStore.assetTracking.tableData = response.data;
              CRMStore.assetTracking.searchCount = filteredCount;
            }
          }}
        />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label style={{ marginRight: '25px' }}><b>Total Asset Count: <span style={{ color: 'blue' }}>{assetCount}</span></b></label>
          {CRMStore.assetTracking.isField === '' && (
            <Button
              positive
              onClick={() => {
                CRMStore.assetTracking.isField = 'Add';
                CRMStore.assetTracking.SelectedRowFormData = createCRMAssetInitialState;
              }}
            >
              Add
            </Button>
          )}
        </div>
      </div>
      <div style={{ margin: '20px' }}>
        {CRMStore.assetTracking.isHistory ? <HistoryModel /> : null}
        <CrmFormFields />
        <DynamicTableComponent
          data={
            CRMStore.assetTracking.deptValue === ''
              ? assetTracking.tableData
              : assetTracking.tableData.filter(
                  (e) => e.department === CRMStore.assetTracking.deptValue,
                )
          }
          name={'CrmAssetTrack'}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={currentPage}
          searchFuncData={searchFunction}
          loading={CRMStore.assetTracking.loading}
        />
      </div>
    </>
  );
};

export default observer(CRMAssetTracking);